import React from 'react';
import type { SectionType } from './types';
import { 
  Image, Type, AlignLeft, Heading, Tag, 
  Layout, MessageSquare, Video, FileText, MousePointer, Minus, Space, List, Quote, Columns2
} from 'lucide-react';

const COMPONENTS: { type: SectionType; label: string; icon: React.ReactNode }[] = [
  { type: 'hero_image', label: 'Feature Image w/ Heading', icon: <Image size={18} /> },
  { type: 'media', label: 'Media (Img/Vid/URL)', icon: <Video size={18} /> },
  { type: 'heading', label: 'Heading', icon: <Heading size={18} /> },
  { type: 'paragraph', label: 'Paragraph', icon: <AlignLeft size={18} /> },
  { type: 'title', label: 'Title', icon: <Type size={18} /> },
  { type: 'tags', label: 'Tags', icon: <Tag size={18} /> },
  { type: 'feature_heading', label: 'Feature Heading w/ Icon', icon: <Layout size={18} /> },
  { type: 'text_area', label: 'Text Area', icon: <FileText size={18} /> },
  { type: 'button', label: 'Button', icon: <MousePointer size={18} /> },
  { type: 'divider', label: 'Divider', icon: <Minus size={18} /> },
  { type: 'spacer', label: 'Spacer', icon: <Space size={18} /> },
  { type: 'list', label: 'List', icon: <List size={18} /> },
  { type: 'quote', label: 'Quote', icon: <Quote size={18} /> },
  { type: 'two_columns', label: '2 Columns', icon: <Columns2 size={18} /> },
  { type: 'contact_form', label: 'Contact Form', icon: <MessageSquare size={18} /> },
];

interface SidebarProps {
  onAdd: (type: SectionType) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ onAdd }) => {
  return (
    <div className="w-64 bg-[#0b0c15] border-r border-white/10 p-4 flex flex-col gap-3 overflow-y-auto h-full">
      <h3 className="text-white font-bold mb-2">Components</h3>
      {COMPONENTS.map((c) => (
        <div 
          key={c.type} 
          onClick={() => onAdd(c.type)}
          className="flex items-center gap-3 p-3 rounded bg-[#1a1a2e] border border-white/5 hover:border-cyan-500/50 cursor-pointer transition-colors text-gray-300 hover:text-white group"
        >
          <div className="text-cyan-500 group-hover:text-cyan-400">{c.icon}</div>
          <span className="text-sm font-medium">{c.label}</span>
        </div>
      ))}
    </div>
  );
};
